import { render } from "./fcs.vue?vue&type=template&id=083a7a8c&scoped=true"
import script from "./fcs.vue?vue&type=script&lang=js"
export * from "./fcs.vue?vue&type=script&lang=js"

import "./fcs.vue?vue&type=style&index=0&id=083a7a8c&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083a7a8c"]])

export default __exports__